import { z } from "zod";

export const ZSpesificationTableRowSchema = z.object({
  spesifikasjonsId: z.string(),
  spesifikasjonsType: z.string(),
  argang: z.string(),
});

export type ISpesificationTableRow = z.infer<typeof ZSpesificationTableRowSchema>;

export const ZNormOrStandardTableRowSchema = z.object({
  normEllerStandard: z.string(),
  utgave: z.string(),
});

export type INormOrStandardTableRow = z.infer<typeof ZNormOrStandardTableRowSchema>;

export const ZElektroSamsvarserklaringFELSchema = z.object({
  generellInfo: z.object({
    utarbeidetAv: z.string(),
    kontrollertAv: z.string(),
    godkjentAv: z.string(),
    dokumentNr: z.string(),
    revisjonsNr: z.string(),
  }),
  oppdragsInfo: z.object({
    oppdragsNavn: z.string(),
    oppdragsNummer: z.string(),
    oppdragsGiver: z.object({
      navn: z.string(),
      kontaktPerson: z.string(),
      adresse: z.string(),
      postNr: z.string(),
      sted: z.string(),
      telefon: z.string(),
      email: z.string(),
      kundenummerEllerProsjektnummer: z.string(),
    }),
    oppdragsLeder: z.string(),
  }),
  prosjekterende: z.object({
    navn: z.string(),
    kontaktPerson: z.string(),
    adresse: z.string(),
    postNr: z.string(),
    sted: z.string(),
    telefon: z.string(),
    email: z.string(),
    oppdragsNummer: z.string(),
  }),
  anleggEllerprosjekt: z.object({
    anleggsnavnEllerProsjektnavn: z.string(),
    adresse: z.string(),
    postNr: z.string(),
    sted: z.string(),
    SSBnr: z.string(),
    typeAnlegg: z.string(),
  }),
  fravikFraAnvendteNormer: z.string(),
  anvendteNormerOgStandarder: z.array(
    z.object({
      normEllerStandard: z.string(),
      utgave: z.string(),
    }),
  ),
  andreTekniskeSpesifikasjoner: z.array(
    z.object({
      spesifikasjonsId: z.string(),
      spesifikasjonsType: z.string(),
      argang: z.string(),
    }),
  ),
  beskrivelseAvOppdrag: z.string(),
  underlagsdokumentasjon: z.object({
    dokumentplan: z.string(),
    fordelingsskjema: z.string(),
    beskrivelser: z.string(),
    resultatFraBrukermoeter: z.string(),
    elektrotekniskeBeregninger: z.string(),
    risikoburdering: z.string(),
  }),
  generatedAt: z.string(),
  generatedBy: z.string(),
});

export type IElektroSamsvarserklaringFELRapport = z.infer<typeof ZElektroSamsvarserklaringFELSchema>;
